import React from 'react';
import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ConfirmationNumber, CalendarMonth } from '@mui/icons-material';
import { AccountData, PassOrderPageData } from '../../../api';
import { customerFacingPriceFormatter } from '../../../orderPage/utils';
import { withBookingFee } from '../../../orderPage/core/pricing';
import { isFixedScheduleMonthly } from '../../../managePassesPage/utils/passUtils';

interface PassHeaderProps {
  name: string;
  passOrderPage: PassOrderPageData;
  account: AccountData;
}

export const PassHeader = ({ name, passOrderPage, account }: PassHeaderProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ marginBottom: isSmallScreen ? 3 : 4 }}>
      <Typography
        variant="h4"
        component="h1"
        sx={{
          fontWeight: 700,
          fontSize: isSmallScreen ? '1.75rem' : '2.25rem',
          lineHeight: 1.2,
          marginBottom: 2,
        }}>
        {name}
      </Typography>

      <Grid container gap={isSmallScreen ? 2 : 3} alignItems="center" flexWrap="wrap">
        {!isFixedScheduleMonthly(passOrderPage.pass_type) && (
          <>
            <Grid container alignItems="center" gap={0.5} width="auto">
              <ConfirmationNumber sx={{ fontSize: 20, color: 'text.secondary' }} />
              <Typography variant="body1" color="text.secondary">
                {passOrderPage.num_punches != null
                  ? t('pass.num_punches_value', { count: passOrderPage.num_punches })
                  : t('pass.unlimited')}
              </Typography>
            </Grid>

            <Grid container alignItems="center" gap={0.5} width="auto">
              <CalendarMonth sx={{ fontSize: 20, color: 'text.secondary' }} />
              <Typography variant="body1" color="text.secondary">
                {t('pass.validity_days_value', { count: passOrderPage.validity_days })}
              </Typography>
            </Grid>
          </>
        )}

        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: 'primary.main',
          }}>
          {customerFacingPriceFormatter(withBookingFee(passOrderPage.price, account), account)}
          {isFixedScheduleMonthly(passOrderPage.pass_type) && ` ${t('manage_passes.buy.perMonth')}`}
        </Typography>
      </Grid>
    </Box>
  );
};
